/* SVT Trend carousel — lazily attaches and plays the row's videos.
   Sources stay in data-src until the card is near the viewport, so a row below the
   fold downloads nothing. */
(function () {
  'use strict';

  function start(video) {
    if (!video.src) {
      video.src = video.dataset.src;
      video.addEventListener(
        'playing',
        function () {
          video.classList.add('is-playing');
        },
        { once: true }
      );
      video.load();
    }
    var played = video.play();
    if (played && played.catch) played.catch(function () {});
  }

  function wire(root) {
    if (root.dataset.svtTrendReady === '1') return;
    root.dataset.svtTrendReady = '1';

    var videos = root.querySelectorAll('.svt-trend__video');
    if (!videos.length) return;

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      // Posters alone carry the row when motion is unwelcome.
      return;
    }

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(videos, start);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) start(video);
          else if (!video.paused) video.pause();
        });
      },
      { rootMargin: '300px 0px', threshold: 0.1 }
    );

    Array.prototype.forEach.call(videos, function (video) {
      observer.observe(video);
    });
  }

  function init() {
    var roots = document.querySelectorAll('[data-svt-trend]');
    for (var i = 0; i < roots.length; i++) wire(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
